import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CouponSearchUserComponent } from './pages/coupon-search-user/coupon-search-user.component';
import { PhysicianListComponent } from './pages/physician-list/physician-list.component';
import { PhysicianDetailsComponent } from './pages/physician-details/physician-details.component';
import { ListPhysicianProceduresComponent } from './pages/list-physician-procedures/list-physician-procedures.component';
import { PurchaseSummaryComponent } from './pages/purchase-summary/purchase-summary.component';
import { PurchaseHistoryComponent } from './pages/purchase-history/purchase-history.component';
import { PurchaseDetailsComponent } from './pages/purchase-details/purchase-details.component';

const routes: Routes = [
  {
    path: '',
    component: CouponSearchUserComponent,
    data: { breadcrumb: 'Buscar clientes' },
  },
  {
    path: 'physician-list',
    component: PhysicianListComponent,
    data: {
      breadcrumb: 'Buscar dentistas',
      parent: { label: 'Buscar clientes', route: '/coupon' },
    },
  },
  {
    path: 'physician-details',
    component: PhysicianDetailsComponent,
    data: {
      breadcrumb: 'Buscar dentistas',
      parent: { label: 'Buscar clientes', route: '/coupon' },
    },
  },
  {
    path: 'procedures',
    component: ListPhysicianProceduresComponent,
    data: {
      breadcrumb: 'Selecionar Procedimentos',
      parent: { label: 'Buscar dentistas', route: '/coupon/physician-list' },
    },
  },
  {
    path: 'purchase-summary',
    component: PurchaseSummaryComponent,
    data: {
      breadcrumb: 'Resumo da Compra',
      parent: { label: 'Buscar dentistas', route: '/coupon/physician-list' },
    },
  },
  {
    path: 'purchase-history',
    component: PurchaseHistoryComponent,
    data: {
      breadcrumb: 'Histórico',
    },
  },
  {
    path: 'purchase-details/:id',
    component: PurchaseDetailsComponent,
    data: {
      breadcrumb: 'Detalhes',
      parent: {
        label: 'Histórico',
        route: '/coupon/purchase-history',
      },
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CouponRoutingModule {}
